import React from 'react';
const pillars = [{
  emoji: '⚡',
  title: 'The Stealth Pantry',
  description: '30 days of food your kids will actually eat — hidden under beds and in closets. Your neighbors will never know.'
}, {
  emoji: '💧',
  title: 'The Apartment Aquifer',
  description: 'Never go thirsty again. 20 gallons of clean water daily from a system that fits in your bathroom closet.'
}, {
  emoji: '🔋',
  title: 'Invisible Energy',
  description: 'Keep your lights, WiFi and medical devices running in complete silence. No generator. No noise. No target on your back.'
}, {
  emoji: '📋',
  title: 'The 30-Day Action Plan',
  description: "From 'zero prepared' to 'fully secure' in one weekend. We eliminate the overwhelm with a daily checklist."
}];
export function SystemSection() {
  return <section className="bg-zinc-50 py-20 px-4 border-y border-zinc-200" data-id="element-117">
      <div className="max-w-5xl mx-auto" data-id="element-118">
        <div className="text-center mb-16" data-id="element-119">
          <h2 className="text-3xl md:text-4xl font-montserrat font-extrabold text-black mb-4" data-id="element-120">
            Stop Being a Target. Start Being Autonomous.
          </h2>
          <p className="text-lg md:text-xl text-zinc-600 max-w-3xl mx-auto" data-id="element-121">
            Our system isn't about "Doomsday." It's about The Next 30 Days. We
            teach you how to turn your current home into a fortress of
            self-reliance without anyone noticing.
          </p>
        </div>

        <h3 className="text-2xl font-montserrat font-bold text-center mb-10 text-zinc-800" data-id="element-122">
          What you'll master in 72 hours:
        </h3>

        <div className="max-w-2xl mx-auto space-y-5" data-id="element-123">
          {pillars.map((pillar, index) => <div key={index} className="flex items-start gap-5 bg-white border border-zinc-100 rounded-xl px-6 py-5 shadow-sm" data-id="element-124">
              <span className="text-3xl leading-none mt-0.5 flex-shrink-0" data-id="element-125">
                {pillar.emoji}
              </span>
              <div data-id="element-126">
                <span className="font-montserrat font-extrabold text-black text-lg" data-id="element-127">
                  {pillar.title}
                </span>
                <span className="text-zinc-600 leading-relaxed" data-id="element-128">
                  {' '}
                  "{pillar.description}"
                </span>
              </div>
            </div>)}
        </div>
        <br data-id="element-129" />
        <div className="text-center" data-id="element-130">
          <a href="#checkout-cta" className="btn-crunchy block w-full md:w-auto px-12 py-6 text-xl md:text-2xl mx-auto mb-6" data-id="element-131">
            GET INSTANT ACCESS NOW — $9.99
          </a>
          <p className="text-zinc-500 text-sm" data-id="element-132">
            One-time payment. No hidden fees. Instant digital delivery.
          </p>
        </div>
      </div>
    </section>;
}